import { useEffect, useState } from "react";
import { Button, Loader } from "@/common/components/ui";
import { CommonSelect } from "@/common/components/features";
import BankDetailsService from "@/services/NPS/Stepper/APIs/BankDetailsService";
import { BankDetailsPayload } from "@/utils/types/NPS/Stepper/BankDetils";
import { Registration } from "@/utils/types/NPS/Stepper/GetRegistrationDetils";
import GetRegistrationDetailsService from "@/services/NPS/Stepper/APIs/getRegistrationDetailsService";

const BankAndNominee: React.FC<{
  ackId: string;
  nextStep: string;
  onPrev: () => void;
  initialDetails: any;
  onNext: () => void;
  setNextStep: (nextStep: string) => void;
  setInitialDetails: (initialDetails: any) => void;
  registrationDetails?: Registration | null;
}> = ({
  ackId,
  onPrev,
  onNext,
  setNextStep,
  setInitialDetails,
  registrationDetails,
}) => {
  // const [nominees, setNominees] = useState([
  //   {
  //     firstName: "",
  //     middleName: "",
  //     lastName: "",
  //     relationship: "",
  //     majorMinor: "",
  //     dob: "",
  //     age: "",
  //     percentage: "",
  //   },
  // ]);

  const [formData, setFormData] = useState({
    accountType: "",
    accountNumber: "",
    ifscCode: "",
    bankName: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (key: string, value: string) => {
    setFormData(prev => ({ ...prev, [key]: value }));
    if (errors[key]) {
      setErrors(prev => ({ ...prev, [key]: "" }));
    }
  };
  // const onVerify = () => {
  //   console.log("Verify");
  // };

  const accountTypeOptions = [
    { label: "Savings Account", value: "SAVINGS" },
    { label: "Current Account", value: "CURRENT" },
    { label: "Others", value: "OTHERS" },
  ];
  const [errors, setErrors] = useState<Record<string, string>>({});
  const validate = () => {
    const validationErrors: Record<string, string> = {};
    if (!formData.accountType) {
      validationErrors.accountType = "Account Type is required";
    }
    if (!formData.accountNumber) {
      validationErrors.accountNumber = "Account Number is required";
    }
    if (!formData.ifscCode) {
      validationErrors.ifscCode = "IFSC Code is required";
    } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(formData.ifscCode)) {
      validationErrors.ifscCode = "Please enter a valid IFSC code";
    }
    if (!formData.bankName) {
      validationErrors.bankName = "Bank Name is required";
    }
    return validationErrors;
  };

  useEffect(() => {
    if (
      registrationDetails?.bankDtls &&
      registrationDetails?.bankDtls?.length > 0
    ) {
      registrationDetails?.bankDtls?.map((item: any) => {
        setFormData({
          accountType: item.accountType,
          accountNumber: item.bankAccountNumber,
          ifscCode: item.bankIfsCode ?? "",
          bankName: item.bankName ?? "",
        });
      });
    }
  }, [registrationDetails]);

  const onSubmit = async () => {
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    try {
      setIsLoading(true);

      // Check if this is the first time submitting bank details
      // bankDtls can be an array or an object with tier1 property
      const bankDtlsArray = Array.isArray(registrationDetails?.bankDtls)
        ? registrationDetails.bankDtls
        : registrationDetails?.bankDtls?.tier1
          ? [registrationDetails.bankDtls]
          : [];

      const isFirstTime =
        !registrationDetails?.bankDtls ||
        bankDtlsArray.length === 0 ||
        (!bankDtlsArray[0]?.tier1 && !bankDtlsArray[0]?.accountType);

      let numberOfSchema = 1; // Default value
      let currentRegistrationDetails = registrationDetails;

      // If first time, use default 1
      if (isFirstTime) {
        numberOfSchema = 1;
      } else {
        // Not first time - check if schemeList has changed
        // Get previously saved numberOfSchema (handle both array and object structures)
        const previousBankDetails = bankDtlsArray[0];
        const previousNumberOfSchema = Number(
          previousBankDetails?.tier1?.numberOfSchema ??
            previousBankDetails?.numberOfSchema ??
            1
        );

        // Get current schemeList length - fetch registration details if not available
        let currentSchemeListLength = 0;

        // Check if schemeList exists in current registrationDetails
        if (
          currentRegistrationDetails?.schemeDtls?.[0]?.schemeList &&
          currentRegistrationDetails.schemeDtls[0].schemeList.length > 0
        ) {
          currentSchemeListLength =
            currentRegistrationDetails.schemeDtls[0].schemeList.length;
        } else {
          // Fetch registration details to get schemeList (first API call)
          try {
            const registrationResponse =
              await GetRegistrationDetailsService.getRegistrationDetails();
            if (
              registrationResponse?.success &&
              registrationResponse?.registration
            ) {
              currentRegistrationDetails = registrationResponse.registration;
              if (
                currentRegistrationDetails?.schemeDtls?.[0]?.schemeList &&
                currentRegistrationDetails.schemeDtls[0].schemeList.length > 0
              ) {
                currentSchemeListLength =
                  currentRegistrationDetails.schemeDtls[0].schemeList.length;
              }
            }
          } catch (fetchError) {
            console.error("Error fetching registration details:", fetchError);
            // Continue with default value if fetch fails
          }
        }

        // Check if schemeList has changed (compare current length with previous numberOfSchema)
        if (
          currentSchemeListLength > 0 &&
          currentSchemeListLength !== previousNumberOfSchema
        ) {
          // SchemeList has changed, use the new length
          numberOfSchema = currentSchemeListLength;
        } else {
          // SchemeList hasn't changed, use default 1
          numberOfSchema = 1;
        }
      }

      const payload = {
        tier1: {
          accountType: formData.accountType,
          bankAccountNumber: formData.accountNumber,
          bankIfsCode: formData.ifscCode,
          bankName: formData.bankName,
          linkedToAdhaarFlag: "Y",
          pennyDropVerf: "Y",
          numberOfNominee:
            currentRegistrationDetails?.nominationDtls?.length ?? 1,
          numberOfSchema: numberOfSchema,
        },
      };
      // Second API call - submit bank details with correct numberOfSchema
      const response = await BankDetailsService.createBankDetails(
        ackId,
        payload as BankDetailsPayload,
        "bank"
      );
      console.log(response, "response");
      if (response.success) {
        // show modal
        // setShowVerifyModal(true);
        setNextStep(response?.registration?.next_step);
        setInitialDetails(response?.registration?.initialDetails);
        onNext();
        // close modal automatically after 2.5 seconds
        // setTimeout(() => {
        //   setShowVerifyModal(false);
        // }, 1000);
      }
    } catch (error) {
      console.error("Error creating bank details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <Loader message="Submitting your bank details..." />}
      <div className="space-y-10 rounded-2xl bg-white py-10">
        {/* Section Title */}
        <h2 className="font-sans text-[20px] font-semibold text-[#66A0CD] md:text-[26px]">
          Bank Details
        </h2>

        {/* ===== Bank Details ===== */}
        <section>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3">
            <CommonSelect
              label="Account Type"
              placeholder="Account Type"
              options={accountTypeOptions}
              value={formData.accountType}
              onChange={val => handleChange("accountType", val)}
              required
              errorMessage={errors.accountType}
            />

            <div className="flex flex-col">
              <label className="mb-1 font-sans text-[16px] font-semibold text-[#707070]">
                Bank A/C Number
                <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="Bank A/C Number"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={18}
                value={formData.accountNumber}
                onChange={e => {
                  let value = e.target.value.replace(/\D/g, ""); // remove non-digits
                  if (value.length > 18) {
                    value = value.slice(0, 18);
                  }
                  handleChange("accountNumber", value);
                }}
                className={`rounded-md border border-[#DFE7EC] px-3 py-2.5 font-sans text-[16px] font-semibold text-[#2F363F] placeholder-[#BECAD0] outline-none focus:border-[#66A0CD] ${errors.accountNumber ? "border-red-500" : ""}`}
              />
              {errors.accountNumber && (
                <p className="mt-1 text-sm text-red-500">
                  {errors.accountNumber}
                </p>
              )}
            </div>

            <div className="flex flex-col">
              <label className="mb-1 font-sans text-[16px] font-semibold text-[#707070]">
                Bank IFSC Code<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="Bank IFSC Code"
                value={formData.ifscCode}
                onChange={e =>
                  handleChange("ifscCode", e.target.value.toUpperCase())
                }
                className={`rounded-md border px-3 py-2.5 font-sans text-[16px] font-semibold text-[#2F363F] placeholder-[#BECAD0] outline-none focus:border-[#66A0CD] ${
                  errors.ifscCode ? "border-red-500" : "border-[#DFE7EC]"
                }`}
              />
              {errors.ifscCode && (
                <p className="mt-1 text-sm text-red-500">{errors.ifscCode}</p>
              )}
            </div>
            <div className="flex flex-col sm:col-span-2 lg:col-span-1">
              <label className="mb-1 font-sans text-[16px] font-semibold text-[#707070]">
                Bank Name<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="Bank Name"
                value={formData.bankName}
                onChange={e =>
                  handleChange("bankName", e.target.value.toUpperCase())
                }
                className={`rounded-md border px-3 py-2.5 font-sans text-[16px] font-semibold text-[#2F363F] placeholder-[#BECAD0] outline-none focus:border-[#66A0CD] ${
                  errors.bankName ? "border-red-500" : "border-[#DFE7EC]"
                }`}
              />
              {errors.bankName && (
                <p className="mt-1 text-sm text-red-500">{errors.bankName}</p>
              )}
            </div>
          </div>
        </section>

        {/* <div className="mt-6 flex justify-end">
          <Button
            type="submit"
            onClick={onSubmit}
            className="h-[50px] w-full rounded-md bg-gradient-to-r from-[#127B8D] to-[#10B981] px-6 py-2 font-sans text-[18px] font-semibold text-white transition hover:opacity-95 md:w-fit"
          >
            Verify
          </Button>
        </div> */}
        {/* Continue Button */}
        <div className="mt-6 flex justify-center gap-3 sm:justify-end md:gap-5">
          <Button
            type="button"
            onClick={() => {
              // setBackFromStep("bank");
              onPrev();
            }}
            className="h-[50px] rounded-md bg-[#F5F5F5] px-8 py-2 font-sans text-[18px] font-semibold text-[#2F363F] hover:bg-[#f5f5f5] hover:opacity-95"
          >
            Back
          </Button>
          <Button
            type="submit"
            onClick={onSubmit}
            className="h-[50px] rounded-md bg-gradient-to-r from-[#127B8D] to-[#10B981] px-6 py-2 font-sans text-[18px] font-semibold text-white transition hover:opacity-95"
          >
            Continue
          </Button>
        </div>
      </div>
      {/* {showVerifyModal && (
        <CommonModal
          isOpen={showVerifyModal}
          // onClose={() => setShowVerifyModal(false)}
          width="450px"
          height="200px"
        >
          <div className="flex flex-col items-center justify-center px-6 py-8">
            <div className="flex h-20 w-20 items-center justify-center rounded-full bg-[#10B981]/10">
              <svg
                className="h-12 w-12 text-[#10B981]"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>

            <h2 className="mt-4 text-xl font-semibold text-[#66A0CD]">
              Bank Verified
            </h2>

            <p className="mt-2 text-center text-gray-600">
              Your bank details were successfully verified.
            </p>
          </div>
        </CommonModal>
      )} */}
    </>
  );
};

export default BankAndNominee;
